import * as organizationsUsersCommands from '@Organizations/Users/commands-vue-composables'
import * as organizationsUsersQueries from '@Organizations/Users/queries-vue-composables'

export function useDashboardPage(){
	return {
		useUserDashboardQuery: organizationsUsersQueries.useUserDashboardQueryV1,
	}
}

export function useUserAccessRequestsPage(){
	return {
		useUserAccessRequestsQuery: organizationsUsersQueries.useUserAccessRequestsQueryV1,
	}
}

export function useUserAccessRequestsRejectedPage(){
	return {
		useUserAccessRequestsQuery: organizationsUsersQueries.useUserAccessRequestsQueryV1,
	}
}

